export default function BillTypeMaster() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Bill Type Master
            </div>
            <div className="page-sub" id="page-sub">
              System › Define charge types, frequency &amp; partial payment
              rules
            </div>
          </div>
          <div className="topbar-right" id="topbar-right">
            <button
              className="btn btn-primary"
              onclick="openBillTypeModal(null)"
            >
              + Add Bill Type
            </button>
          </div>
        </div>
        <div className="content" id="content-area">
          <div className="info-box mb16">
            <strong>Bill Type Master</strong> — define all charge types
            available on the platform (Rent, Electricity, Water, Gas,
            Maintenance, etc.). Property owners will use these when configuring
            charges for each room/unit. Frequency, Charge Type, and Partial
            Payment settings become the defaults at the room level but can be
            overridden.
          </div>
          <div className="card">
            <div style={{ overflowX: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: 50 }}>Order</th>
                    <th style={{ width: 40 }}>Icon</th>
                    <th style={{ minWidth: 140 }}>Charge Name</th>
                    <th>Description</th>
                    <th style={{ minWidth: 120 }}>Frequency</th>
                    <th style={{ minWidth: 130 }}>Charge Type</th>
                    <th style={{ minWidth: 130 }}>Partial Pay</th>
                    <th style={{ width: 70 }}>Active</th>
                    <th style={{ minWidth: 160 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="sn-col">1</td>
                    <td>
                      <span style={{ fontSize: 18 }}>⚡</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Electricity</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Electricity/power consumption charge
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-teal">Per Unit</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(2,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(2)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(2,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(2,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(2,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(2)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(2,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">2</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🏠</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Rent</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Monthly room/unit rent charge
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-active">✓ Yes</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(1,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(1)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(1,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(1,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(1,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(1)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(1,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">3</td>
                    <td>
                      <span style={{ fontSize: 18 }}>💧</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Water</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Water usage charge
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(3,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(3)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(3,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(3,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(3,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(3)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(3,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">4</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🔥</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Gas</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Gas/LPG cylinder charge
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(4,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(4)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(4,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(4,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(4,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(4)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(4,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">5</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🔧</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Maintenance</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Society maintenance / housekeeping
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-purple">% of Rent</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(5,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(5)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(5,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(5,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(5,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(5)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(5,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">6</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🅿️</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Parking</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Vehicle parking charges
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(6,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(6)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(6,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(6,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(6,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(6)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(6,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">7</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🏊</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Club / Amenity</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Club house or amenity access fee
                    </td>
                    <td>
                      <span className="badge badge-info">Monthly</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-gray">✕ No</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(7,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(7)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(7,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(7,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(7,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(7)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(7,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">8</td>
                    <td>
                      <span style={{ fontSize: 18 }}>🔐</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Security Deposit</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      One-time refundable security deposit
                    </td>
                    <td>
                      <span className="badge badge-info">One-time</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-active">✓ Yes</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(8,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(8)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(8,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(8,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(8,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(8)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(8,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">9</td>
                    <td>
                      <span style={{ fontSize: 18 }}>📅</span>
                    </td>
                    <td style={{ fontWeight: 600 }}>Advance Rent</td>
                    <td
                      style={{ fontSize: 11, color: "var(--text-secondary)" }}
                    >
                      Advance rent collected at move-in
                    </td>
                    <td>
                      <span className="badge badge-info">One-time</span>
                    </td>
                    <td>
                      <span className="badge badge-info">₹ Fixed</span>
                    </td>
                    <td>
                      <span className="badge badge-active">✓ Yes</span>
                    </td>
                    <td>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          defaultChecked=""
                          onchange="toggleBillType(9,this.checked)"
                        />
                        <span className="toggle-slider" />
                      </label>
                    </td>
                    <td>
                      <div className="td-actions">
                        <span
                          className="action-icon"
                          onclick="openBillTypeModal(9)"
                        >
                          <span className="tip">Edit</span>✎
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(9,-1)"
                        >
                          <span className="tip">Move Up</span>▲
                        </span>
                        <span
                          className="action-icon amber"
                          onclick="moveBillType(9,1)"
                        >
                          <span className="tip">Move Down</span>▼
                        </span>
                        <span
                          className="action-icon red"
                          onclick="toggleBillType(9,false)"
                        >
                          <span className="tip">Deactivate</span>⏸
                        </span>
                        <span
                          className="action-icon red"
                          onclick="deleteBillType(9)"
                        >
                          <span className="tip">Delete</span>🗑
                        </span>
                      </div>
                      <div style={{ marginTop: 4 }}>
                        <button
                          className="btn btn-xs btn-danger"
                          onclick="toggleBillType(9,false)"
                        >
                          ⏸ Deactivate
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
